<template>
  <div>
    <v-sheet
      color="primary"
      class="pa-3 ma-3 mt-3 white--text gradient ml-8"
      style="display:grid; grid-template-columns: 1fr max-content max-content max-content; align-items:center;border-radius: 1rem;"
    >
      <div
        class="primary pa-2 ml-3"
        style="text-align:center;position:absolute;left: 0rem;top:5.5rem;border-radius: 50%;"
      >
        <sabira_icon
          icon="outbox"
          :height="44"
          :width="44"
          class="pa-2"
          fill="#fff"
        ></sabira_icon>
      </div>
      <div style="display:grid;" class="ml-10">
        <div
          style="font-size: 1rem;font-family: 'Open Sans';font-weight: 700;color:#fff"
        >
          IZLAZNE FAKTURE
        </div>
      </div>
      <div class="mr-4">Zapisi: {{ listaFaktura.length }}</div>
      <v-tooltip left color="#e9c46a" open-on-hover open-delay="150">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="new_item()"
            color="transparent"
            depressed
            icon
            v-bind="attrs"
            v-on="on"
            class="mr-2"
          >
            <sabira_icon
              icon="plus"
              :strokewidth="3"
              :width="34"
              :height="34"
              fill="white"
            ></sabira_icon>
          </v-btn>
        </template>
        <span>Nova izlazna faktura</span>
      </v-tooltip>
      <invoicesExcel :data="this.listaFaktura" />
    </v-sheet>
    <v-card class="ma-4" flat color="tertiary" style="border-radius: 1rem;">
      <v-card-text>
        <div
          style="display:grid;grid-template-columns: 1fr max-content max-content max-content; align-items:center;grid-column-gap:1rem;"
        >
          <v-text-field
            clearable
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Pretraga izlaznih faktura"
            placeholder="Unesite naziv pojma za pretragu"
            v-model="search_text"
            outlined
          ></v-text-field>
          <v-select
            class="type"
            mandatory
            :items="filteri"
            item-text="name"
            outlined
            hide-details
            return-object
            label="Vrsta fakture"
            v-model="selected_filter"
          >
          </v-select>
          <v-select
            class="select"
            mandatory
            :items="years"
            outlined
            hide-details
            label="Godina"
            v-model="selected_year"
          />
          <sabira_invoice_header></sabira_invoice_header>
        </div>
        <v-card flat v-if="is_loading">
          <v-skeleton-loader type="table, list-item@6" />
        </v-card>
        <template v-else>
          <v-data-table
            style="background: transparent;"
            no-data-text="Podaci ne postoje za odabranu kategoriju"
            :search="search_text"
            :items="listaFaktura"
            :headers="headers"
            :options="{ itemsPerPage: 50 }"
            :item-class="status_fakture"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, -1],
              'items-per-page-text': 'Broj zapisa po stranici',
              'items-per-page-all-text': 'Svi',
              'page-text': '{0}-{1} od {2}',
            }"
          >
            <template v-slot:[`item.naziv`]="{ item }">
              <div class="body-2" style="font-weight: 500;">
                {{ item.naziv }}
              </div>
              <div class="text-caption">
                {{ item.napomena }}
              </div>
            </template>
            <template v-slot:[`item.datum`]="{ item }">
              {{ $moment(new Date(item.datum)).format("L") }}
            </template>
            <template v-slot:[`item.total`]="{ item }">
              {{ $n(parseFloat(item.total).toFixed(2)) }}
            </template>
            <template v-slot:[`item.ukupno`]="{ item }">
              {{ $n(parseFloat(item.ukupno).toFixed(2)) }}
            </template>
            <template v-slot:[`item.pdv`]="{ item }">
              {{ $n(parseFloat(item.pdv).toFixed(2)) }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn v-if="item.is_ko == 0" icon @click="open_invoice(item)"
                ><v-icon>mdi-open-in-new</v-icon></v-btn
              >
            </template>
            <template v-slot:[`item.broj`]="{ item }">
              <div style="display:grid;grid-template-columns: max-content 1fr">
                <div class="mt-2 mb-2">
                  <div>{{ item.broj }}</div>
                </div>
              </div>
            </template>
          </v-data-table>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {
    sabira_icon: () => import("@/components/sabira_icon"),
    sabira_invoice_header: () => import("@/components/invoice_header"),
    invoicesExcel: () => import("@/components/excel/invoicesExcel.vue"),
  },
  name: "Fakture",
  data() {
    return {
      ExportExcel: false,
      is_loading: true,
      selected_filter: null,
      selected_year: new Date().getFullYear(),
      listaFaktura: [],
      search_text: null,
      years: [
        new Date().getFullYear(),
        new Date().getFullYear() - 1,
        new Date().getFullYear() - 2,
        new Date().getFullYear() - 3,
        new Date().getFullYear() - 4,
        new Date().getFullYear() - 5,
      ],
      filteri: [
        {
          id: 0,
          name: "Sve",
        },
        {
          id: 1,
          name: "Aktivne",
        },
        {
          id: 2,
          name: "KO",
        },
        {
          id: 3,
          name: "Storno",
        },
      ],
      headers: [
        {
          text: "ID",
          value: "id",
          sortable: true,
          align: "left d-none",
        },
        {
          text: "Broj fakture",
          value: "broj",
          sortable: true,
          width: 150,
        },
        {
          text: "Datum",
          value: "datum",
          sortable: true,
          width: 160,
        },
        {
          text: "Klijent",
          value: "naziv",
          sortable: true,
        },
        {
          text: "Fiskalni račun",
          value: "fiskalni_broj",
          sortable: true,
          width: 130,
          align: "center",
        },
        {
          text: "Vrijednost",
          value: "total",
          sortable: true,
          width: 120,
          align: "right",
        },
        {
          text: "PDV",
          value: "pdv",
          sortable: true,
          width: 120,
          align: "right",
        },
        {
          text: "Ukupno",
          value: "ukupno",
          sortable: true,
          width: 120,
          align: "right",
        },
        {
          text: null,
          value: "actions",
          width: 40,
        },
      ],
    };
  },
  methods: {
    new_item() {
      this.$webpageEventBus.$emit("show_faktura", {
        id: 0,
        artikli: [],
        broj: null,
        fiskalni_broj: null,
        payment_type: null,
        uplatiti_do: this.$moment(new Date())
          .local()
          .format("YYYY-MM-DD"),
        datum_kreiranja: this.$moment(new Date())
          .local()
          .format("YYYY-MM-DD"),
        napomena: null,
        dispatch_note: null,
      });
    },
    status_fakture(faktura) {
      if (faktura.napomena !== null && faktura.napomena.includes("Storno")) {
        return "faktura_storno";
      } else if (faktura.is_ko == 1) {
        return "faktura_ko";
      }
      return null;
    },
    get_items() {
      this.is_loading = true;
      this.$http({
        method: "POST",
        url: "/fakture",
        data: {
          type: this.selected_filter.id,
          account_id: this.$store.getters.user.account_id,
          year: this.selected_year,
        },
      })
        .then((resp) => {
          this.listaFaktura = resp.data[0];
          this.is_loading = false;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    open_invoice(invoice) {
      this.$webpageEventBus.$emit("show_faktura", invoice);
    },
  },
  watch: {
    selected_year: {
      handler() {
        this.get_items(this.selected_filter.id);
      },
      immediate: false,
    },
    selected_filter: {
      handler() {
        this.get_items(this.selected_filter.id);
      },
      immediate: false,
    },
  },
  mounted() {
    this.selected_filter = this.filteri[0];
    this.$webpageEventBus.$on("close_faktura", () => {
      this.selected_id = null;
      this.get_items();
    });

    this.$webpageEventBus.$on("reload_data", () => {
      this.get_items();
    });
    this.$webpageEventBus.$emit("toggle_navigation");
  },
};
</script>
<style>
.faktura_storno {
  background-color: rgba(255, 0, 0, 0.2) !important;
}
.faktura_ko {
  background-color: rgb(108, 173, 216, 0.2) !important;
}
.gradient {
  background-image: linear-gradient(to right, #6172ca, #6cadd8);
}
.select {
  width: 94px;
}
.type {
  width: 120px;
}
.v-tooltip__content {
  color: black;
  opacity: 1;
}
</style>
